var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-button",class:{ checkapp: _vm.platform === 'checkapp', disabled: _vm.disabled },on:{"click":_vm.clicked}},[_c('span',{class:{ disabled: _vm.disabled }},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }